import api from '../httpClient'

export type ChecklistItem = {
  id: string
  title: string
  description?: string
  dueDate?: string | null
  completedAt?: string | null
  completionSource?: string | null
  externalUrl?: string | null
  questionFlow?: number | null
  questionFlowName?: string | null
  metadata?: Record<string, unknown>
  media?: {
    id: number | string
    url?: string | null
    mediaType?: string | null
    storageKey?: string | null
  } | null
}

const normalize = (item: any): ChecklistItem => ({
  id: item.id,
  title: item.title,
  description: item.description ?? '',
  dueDate: item.due_date ?? null,
  completedAt: item.completed_at ?? null,
  completionSource: item.completion_source ?? null,
  externalUrl: item.external_url ?? null,
  questionFlow: item.question_flow ?? null,
  questionFlowName: item.question_flow_name ?? null,
  metadata: item.metadata ?? {},
  media: item.media
    ? {
        id: item.media.id,
        url: item.media.url ?? null,
        mediaType: item.media.media_type ?? null,
        storageKey: item.media.storage_key ?? null,
      }
    : item.media_asset
    ? {
        id: item.media_asset.id,
        url: item.media_asset.url ?? null,
        mediaType: item.media_asset.media_type ?? null,
        storageKey: item.media_asset.storage_key ?? null,
      }
    : null,
})

export const checklist = {
  list: async (): Promise<ChecklistItem[]> => {
    const response = await api.get('/api/checklist-items/')
    return Array.isArray(response.data) ? response.data.map(normalize) : []
  },
  markComplete: async (id: string): Promise<ChecklistItem> => {
    const response = await api.post(`/api/checklist-items/${id}/complete/`, {})
    return normalize(response.data)
  },
  markIncomplete: async (id: string): Promise<ChecklistItem> => {
    const response = await api.post(`/api/checklist-items/${id}/incomplete/`, {})
    return normalize(response.data)
  },
}
